var _polyline, _polyline2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconRefresh = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "icon icon--refresh",
  ref: svgRef
}, props), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  points: "23 4 23 10 17 10"
})), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
  points: "1 20 1 14 7 14"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconRefresh, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconRefresh.46088c6c.svg";
export { ForwardRef as ReactComponent };